import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TaxTariffTranche from './tax-tariff-tranche';
import TaxTariffTrancheDetail from './tax-tariff-tranche-detail';
import TaxTariffTrancheUpdate from './tax-tariff-tranche-update';
import TaxTariffTrancheDeleteDialog from './tax-tariff-tranche-delete-dialog';

const TaxTariffTrancheRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TaxTariffTranche />} />
    <Route path="new" element={<TaxTariffTrancheUpdate />} />
    <Route path=":id">
      <Route index element={<TaxTariffTrancheDetail />} />
      <Route path="edit" element={<TaxTariffTrancheUpdate />} />
      <Route path="delete" element={<TaxTariffTrancheDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TaxTariffTrancheRoutes;
